export const COMMON = {
  ROOT_REDUCER: "users",
};
